module.exports = __webpack_public_path__ + "static/media/eye-icon.0bb20154.svg";